var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"20px"}},[_c('GestioneModuli')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }